import { MessageCircleQuestion } from 'lucide-react'
import { toast } from '@/components/ui/sonner'

import { SidebarMenuButton } from '@/components/ui/sidebar'
import { Small } from '../ui/typography'

export function NavChatlio() {
    const handleChatlioClick = () => {
        if (typeof window !== 'undefined' && window._chatlio) {
            window._chatlio.show({ expanded: true })
        } else {
            toast.info(
                'We are temporarily away. Please check back later or email us at support@blackcrow.ai',
                {
                    duration: 5000,
                },
            )
        }
    }

    return (
        <SidebarMenuButton
            size="sm"
            variant="outline"
            className="hover:bg-primary/90 border p-4 border-primary"
            onClick={handleChatlioClick}
        >
            <MessageCircleQuestion />
            <Small>Chat with support</Small>
        </SidebarMenuButton>
    )
}
